import { Carousel, CarouselSlide } from '@mantine/carousel';
import { Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { devicePageModel, DevicePageTabValues } from 'pages/device-page/model';
import { DevicePageForm } from '../device-page-form';
import { DevicePagePlayers } from '../device-page-players';
import cls from './device-page-tabs.module.scss';

export const DevicePageTabs = () => {
	const { t } = useTranslation();

	const { value, setValue } = useUnit(devicePageModel.currentTabState);

	return (
		<Tabs
			variant='default'
			keepMounted={false}
			classNames={{
				root: cls.devicePageTabs,
				panel: cls.devicePageTabsPanel,
				list: cls.devicePageTabsList,
			}}
			defaultValue='info'
			value={value}
			onChange={(v) => setValue(v as DevicePageTabValues)}
		>
			<Tabs.List>
				<Carousel
					slideSize='auto'
					emblaOptions={{ dragFree: true }}
				>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='device-page-info-tab'
							value='info'
						>
							{t('device-page.info')}
						</Tabs.Tab>
					</CarouselSlide>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='device-page-players-tab'
							value='players'
						>
							{t('device-page.players')}
						</Tabs.Tab>
					</CarouselSlide>
				</Carousel>
			</Tabs.List>
			<Tabs.Panel value='info'>
				<DevicePageForm />
			</Tabs.Panel>
			<Tabs.Panel value='players'>
				<DevicePagePlayers />
			</Tabs.Panel>
		</Tabs>
	);
};
